// extracted by mini-css-extract-plugin
module.exports = {"Signup":"Signup_Signup__2e5-8"};